import { Scroller } from './Scroller';

export class WindowScroller implements Scroller {
    scrollTo = (x: number, y: number): void => {
        window.scrollTo(x, y);
    };
}
